// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /recebimentos/delete
 *
 * Deletes a recebimento by ID.
 */
import { registerContract } from './validate'

export interface Recebimentos_DeleteInput {
recebimento_id: number
}

registerContract('Recebimentos_DeleteInput', {
  recebimento_id: { type: 'number',  required: true },
})
